import { render, staticRenderFns } from "./ListMyDocuments.vue?vue&type=template&id=87f72b26&"
import script from "./ListMyDocuments.vue?vue&type=script&lang=js&"
export * from "./ListMyDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87f72b26')) {
      api.createRecord('87f72b26', component.options)
    } else {
      api.reload('87f72b26', component.options)
    }
    module.hot.accept("./ListMyDocuments.vue?vue&type=template&id=87f72b26&", function () {
      api.rerender('87f72b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyDocumentsMobile/ListMyDocuments.vue"
export default component.exports